import { axiosPublic } from "@/lib/axios/axios-public";
import { ApiError } from "@/lib/api/errors";
import type { AppTokenPair } from "@/types/auth-api-types";

type RefreshTokenResponse = {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  tokenType?: string;
};

/** Exchange a refresh token for a new application JWT pair. */
export async function exchangeRefreshToken(
  refreshToken: string,
): Promise<AppTokenPair> {
  try {
    const { data } = await axiosPublic.post<RefreshTokenResponse>(
      "/api/auth/token/refresh",
      { refreshToken },
    );

    if (!data?.accessToken?.trim() || !data?.refreshToken?.trim()) {
      throw new ApiError(
        "We couldn't refresh your session. Please sign in again.",
        401,
      );
    }

    return {
      accessToken: data.accessToken.trim(),
      refreshToken: data.refreshToken.trim(),
      expiresIn: data.expiresIn,
    };
  } catch (err) {
    if (err instanceof ApiError) throw err;
    throw new ApiError(
      "We couldn't refresh your session. Please sign in again.",
      401,
    );
  }
}
